import axios from "axios";
import { BASE_URL } from "./api";

export async function deleteTask(actionId, token) {
    return axios({
        method: 'delete',
        url: `${BASE_URL}/client_tasks/${actionId}/`,
        headers: {
            'Authorization': `Token ${token}`, 
            'Content-Type': 'application/json'
        }
    })
    .then(response => response)
    .catch(error => alert(error))
}

export async function bulkUpdateOrdinals(data, token) {
    return axios({
        method: "put",
        url: `${BASE_URL}/client_tasks/bulk_update_ordinals/`,
        headers: {
            'Authorization': `Token ${token}`,
            'Content-Type': 'application/json',
        },
        data: data
    })
    .then(response => response)
    .catch(error => error)
}
